// Textos y formatos compartidos por las pantallas de contratos y préstamos

export const CONTRACT_TYPES = {
    TRIAL: 'Préstamo',
    RENT: 'Alquiler',
    PURCHASE: 'Compra',
    FOLLOW_UP: 'Seguimiento',
};

export const CONTRACT_STATUSES = {
    ACTIVE: 'Activo',
    SUSPENDED: 'Suspendido',
    ENDED: 'Terminado',
    EXPIRED: 'Vencido',
    CONVERTED: 'Convertido',
};

export const TYPE_OPTIONS = Object.entries(CONTRACT_TYPES).map(([value, label]) => ({ value, label }));
export const STATUS_OPTIONS = Object.entries(CONTRACT_STATUSES).map(([value, label]) => ({ value, label }));

// Igual que el backend (SellerService)
export const DEFAULT_TRIAL_DAYS = 15;
export const MAX_TRIAL_DAYS = 20;

// La API envía fechas "AAAA-MM-DD"; se formatean sin pasar por Date para no correr el día por zona horaria
export const formatDate = (isoDate) => {
    if (!isoDate) return '-';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
};

// Fecha local de hoy (+ días) en formato "AAAA-MM-DD" para inputs type="date"
export const isoDatePlusDays = (days = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const isOpen = (contract) => contract.status === 'ACTIVE' || contract.status === 'SUSPENDED';

const BADGE = {
    ACTIVE: 'bg-green-100 text-green-800',
    SUSPENDED: 'bg-red-100 text-red-800',
    ENDED: 'bg-gray-200 text-gray-700',
    EXPIRED: 'bg-gray-200 text-gray-700',
    CONVERTED: 'bg-blue-100 text-blue-800',
    GRACE: 'bg-yellow-100 text-yellow-800',
};

export const statusBadge = (contract) => {
    if (contract.inGrace) {
        return { label: 'Pago vencido', className: BADGE.GRACE };
    }
    return { label: CONTRACT_STATUSES[contract.status] || contract.status, className: BADGE[contract.status] };
};

// Resumen legible de la vigencia: "Vence en 5 días", "Gracia hasta 20/10/2026", "Sin vencimiento"
export const validityText = (contract) => {
    if (!isOpen(contract)) {
        return contract.endedOn ? `Cerrado el ${formatDate(contract.endedOn)}` : '-';
    }
    if (contract.status === 'SUSPENDED') {
        return contract.validUntil ? `Pagado hasta ${formatDate(contract.validUntil)}` : 'Suspendido';
    }
    if (!contract.validUntil) {
        return 'Sin vencimiento';
    }
    if (contract.inGrace) {
        return `Se suspende después del ${formatDate(contract.graceUntil)}`;
    }
    if (contract.daysLeft === 0) {
        return 'Vence hoy';
    }
    return `Vence en ${contract.daysLeft} día${contract.daysLeft === 1 ? '' : 's'}`;
};

export const inputClass = 'block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded shadow-md';
export const labelClass = 'block font-semibold text-black mb-1';
export const primaryButton = 'flex items-center justify-center px-4 py-2 bg-blue-600 hover:bg-blue-800 text-white rounded shadow text-sm transition duration-200 disabled:opacity-50';
export const secondaryButton = 'flex items-center justify-center px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-900 rounded shadow text-sm transition duration-200';
export const actionLink = 'text-blue-600 hover:text-blue-800 hover:underline text-sm whitespace-nowrap';
export const dangerLink = 'text-red-600 hover:text-red-800 hover:underline text-sm whitespace-nowrap';
